import React from 'react';
import { processSilentRenew } from 'redux-oidc';

export const SilentRenew = () => {
  processSilentRenew();
  return <></>;
};
